<template>
  <div>
    <div style="background-color: white; padding: 15px;">
      <div>
        <span style="font-size: 13px; color:#97a8be">首页 / 用户管理 / 用户列表</span>
      </div>
    </div>
    <div style="overflow:hidden; padding:15px 15px; padding-top: 0; line-height: 43px ">
      <span class="leftTd">ID</span>
      <input class="boxText" v-model="id" style="width: 200px; margin-left: 10px;">
      <span class="leftTd" style="margin-left: 15px;">账号</span>
      <input class="boxText" v-model="account" style="width: 200px; margin-left: 10px;">
      <span class="leftTd" style="margin-left: 15px;">姓名</span>
      <input class="boxText" v-model="name" style="width: 200px; margin-left: 10px;">

      <span class="leftTd" style="margin-left: 15px;">手机号码</span>
      <input class="boxText" v-model="phone" style="width: 200px; margin-left: 10px;">
      <span class="leftTd" style="margin-left: 15px;">身份证</span>
      <input class="boxText" v-model="card" style="width: 200px; margin-left: 10px;">
      <span class="leftTd" style="margin-left: 15px;">推荐人</span>
      <input class="boxText" v-model="recommender" style="width: 200px; margin-left: 10px;">

      <span class="leftTd" style="margin-left: 15px;">用户类型</span>
      <select class="boxText" v-model="type" style="width: 200px; margin-left: 10px;">
        <option value="">全部</option>
        <option value="0">会员</option>
        <option value="1">业务员</option>
      </select>
      <span class="leftTd" style="margin-left: 15px;">状态</span>
      <select class="boxText" v-model="state" style="width: 200px; margin-left: 10px;">
        <option value="">全部</option>
        <option value="0">启用</option>
        <option value="1">禁用</option>
      </select>
      <span class="leftTd" style="margin-left: 15px;">等级</span>
      <select v-model="level" class="boxText" style="width: 200px; margin-left: 10px;">
        <option value="">全部</option>
        <option :key="index" v-for="(value,index) in levelList" :value="value.levelId">{{value.levelName}}</option>
      </select>
      <span class="leftTd" style="margin-left: 15px;">团队等级</span>
      <select v-model="teamLevel" class="boxText" style="width: 200px; margin-left: 10px;">
        <option value="">全部</option>
        <option :key="index" v-for="(value,index) in teamLevelList" :value="value.levelId">{{value.levelName}}</option>
      </select>
      <input @click="selectAdminList" type="button" style="cursor: pointer; padding: 7px 25px; border-radius: 3px; margin-left: 10px; background-color: #1890ff; border: 1px solid #1890ff; color: white" value="搜索" />
    </div>
    <div style="overflow:hidden; padding:0 15px;">
      <div @click="addAdmin" class="addBtn">+ 注册用户</div>
    </div>
    <div style="padding: 10px 15px">
      <div style="overflow-x: scroll">
        <table>
          <tr>
            <th class="th">
              操作
            </th>
            <th class="th">
              用户ID
            </th>
            <th class="th">
              登录账号
            </th>
            <th class="th">
              姓名
            </th>
            <th class="th">
              昵称
            </th>
            <th class="th">
              手机号码
            </th>
            <th class="th">邮箱</th>
            <th class="th">身份证</th>
            <th class="th">等级</th>
            <th class="th">团队等级</th>
            <th class="th">余额</th>
            <th class="th">金币</th>
            <th class="th">USDT</th>
            <th class="th">余额宝</th>
            <th class="th">推荐人</th>
            <th class="th">顶级账户</th>
            <th class="th">用户类型</th>
            <th class="th">状态</th>
            <th class="th">近期IP</th>
            <th class="th">USDT地址</th>
            <th class="th">单日转账上限</th>
            <th class="th">今日投资金额</th>
            <th class="th">今日收益</th>
            <th class="th">今日余额宝收益</th>
            <th class="th">累计投资金额</th>
            <th class="th">累计收益</th>
            <th class="th">累计余额宝收益</th>
            <th class="th">注册时间</th>
          </tr>
          <tr :key="index" v-for="(value,index) in adminList">
            <td class="td">
              <div style="overflow: hidden;min-width: 150px;">
                <div @click="updateAdmin(value)" style="cursor: pointer; float: left; color: #1890ff">
                  <img src="@/assets/home/update.png" style="height: 18px; vertical-align: middle" />
                  修改
                </div>
                <div @click="childUser(value.userCode)" style="cursor: pointer; margin-left: 10px; float: left; color: #1890ff">
                  <img src="@/assets/home/chakan.png" style="height: 18px; vertical-align: middle" />
                  下级用户
                </div>
                <div @click="riskPage(value.userCode)" style="cursor: pointer; margin-left: 10px; float: left; color: #1890ff">
                  风险评估
                </div>
              </div>
            </td>
            <td class="td" :style="{color:value.userType==1?'red':'#606266'}">
              {{ value.userCode }}
            </td>
            <td class="td" :style="{color:value.userType==1?'red':'#606266'}">
              {{ value.userAccount }}
            </td>
            <td class="td" :style="{color:value.userType==1?'red':'#606266'}">
              {{value.userName}}
            </td>
            <td class="td" :style="{color:value.userType==1?'red':'#606266'}">
              {{value.userNickName}}
            </td>
            <td class="td" :style="{color:value.userType==1?'red':'#606266'}">
              {{ value.userPhone }}
            </td>
            <td class="td" :style="{color:value.userType==1?'red':'#606266'}">{{ value.userEmail }}</td>
            <td class="td" :style="{color:value.userType==1?'red':'#606266'}">{{ value.userCard }}</td>
            <td class="td" :style="{color:value.userType==1?'red':'#606266'}">{{ value.userLevel }}</td>
            <td class="td" :style="{color:value.userType==1?'red':'#606266'}">{{ value.userTeamLevel }}</td>
            <td class="td" :style="{color:value.userType==1?'red':'#606266'}">{{ value.userPrice }}</td>
            <td class="td" :style="{color:value.userType==1?'red':'#606266'}">{{ value.userGold }}</td>
            <td class="td" :style="{color:value.userType==1?'red':'#606266'}">{{ value.userUsdt }}</td>
            <td class="td" :style="{color:value.userType==1?'red':'#606266'}">{{ value.userBalance }}</td>
            <td class="td" :style="{color:value.userType==1?'red':'#606266'}">{{ value.userRecommender }}</td>
            <td class="td" :style="{color:value.userType==1?'red':'#606266'}">{{ value.boss }}</td>
            <td class="td" :style="{color:value.userType==1?'red':'#606266'}">{{ value.userType==0?'会员':'业务员' }}</td>
            <td class="td" :style="{color:value.userType==1?'red':'#606266'}">{{ value.userState==0?'正常':'冻结' }}</td>
            <td class="td" :style="{color:value.userType==1?'red':'#606266'}">{{ value.userIp }}</td>
            <td class="td" :style="{color:value.userType==1?'red':'#606266'}">{{ value.userUsdtAddress }}</td>
            <td class="td" :style="{color:value.userType==1?'red':'#606266'}">{{ value.userTransferNum }}</td>
            <td class="td" :style="{color:value.userType==1?'red':'#606266'}">{{ value.userTodayInvestPrice }}</td>
            <td class="td" :style="{color:value.userType==1?'red':'#606266'}">{{ value.userTodayEarnings }}</td>
            <td class="td" :style="{color:value.userType==1?'red':'#606266'}">{{ value.userTodayBalance }}</td>
            <td class="td" :style="{color:value.userType==1?'red':'#606266'}">{{ value.userHistoryInvestPrice }}</td>
            <td class="td" :style="{color:value.userType==1?'red':'#606266'}">{{ value.userHistoryEarnings }}</td>
            <td class="td" :style="{color:value.userType==1?'red':'#606266'}">{{ value.userHistoryBalance }}</td>
            <td class="td" :style="{color:value.userType==1?'red':'#606266'}">{{ value.userTime }}</td>

          </tr>
        </table>
      </div>
      <div style="padding-top: 20px; font-size: 12px; color: #606266; text-align: right">
        一页显示 <input v-model="num" style="text-align: center; width: 30px; min-width: 30px;" class="text1"/>
        条，共<span v-html="count"></span>条数据
        <img src="@/assets/home/shuaxin.png" v-on:click="selectAdminList()" title="刷新"
             style="vertical-align: middle; height: 18px; cursor:pointer; margin-left: 10px;"/>
        <img src="@/assets/home/shouye.png" v-on:click="currPage(1)" title="首页"
             style="vertical-align: middle; height: 18px; cursor:pointer; margin-left: 10px;"/>
        <img src="@/assets/home/shangyiye.png" v-on:click="currPage(2)" title="上一页"
             style="vertical-align: middle; height: 18px; cursor:pointer; margin-left: 10px;"/>
        <input v-model="page" style="text-align: center; width: 30px; min-width: 30px;" class="text1"/> / <span
          v-html="countPage"></span>页
        <img src="@/assets/home/xiayiye.png" v-on:click="currPage(3)" title="下一页"
             style="vertical-align: middle; height: 18px; cursor:pointer; margin-left: 10px;"/>
        <img src="@/assets/home/weiye.png" v-on:click="currPage(5)" title="尾页"
             style="vertical-align: middle; height: 18px; cursor:pointer; margin-left: 10px;"/>
        <img src="@/assets/home/shuaxin.png" v-on:click="selectAdminList()" title="刷新"
             style="vertical-align: middle; height: 18px; cursor:pointer; margin-left: 10px;"/>
      </div>
    </div>
  </div>
</template>

<script>

import {closeLoading, DO_NET_URL, loading, toask} from "@/config/config";
import {axiosGet, axiosPost} from "@/main";

export default {
  name: "UserList",
  data(){
    return{
      id:"",
      account:"",
      name:"",
      phone:"",
      card:"",
      level:"",
      teamLevel:"",
      recommender:"",
      type:"",
      state:"",
      adminList:[],
      page:1,
      num:10,
      count:0,
      countPage:0,
      imgUrl:"",
      levelList:[],
      teamLevelList:[]
    }
  },
  mounted(){
    let that=this
    if(localStorage.getItem("iwa_token")==null||localStorage.getItem("iwa_token")==""){
      setTimeout(function (){
        that.$router.replace('index')
      },600);
    }
    axiosGet(DO_NET_URL+"api/GetLevel",function (res){
      console.log(res.data)
      that.levelList=res.data
    })
    axiosGet(DO_NET_URL+"teamLevel/GetLevel",function (res){
      console.log(res.data)
      that.teamLevelList=res.data
    })
    this.selectAdminList()
  },
  methods: {
    childUser(code){
      localStorage.setItem("userCode",code)
      this.openCenteredWindow("#/childUser", 800,600)
      //this.$emit("send","childUser")
    },
    riskPage(code){
      localStorage.setItem("userCode",code)
      this.openCenteredWindow("#/riskPage", 800,600)
      //this.$emit("send","childUser")
    },
    updateAdmin(obj){
      localStorage.setItem("UPDATEOBJ",JSON.stringify(obj))
      this.openCenteredWindow("#/updateUser", 800,600)
      //this.$emit("send",'updateUser')
    },
    openCenteredWindow(url, width, height) {
      // 计算窗口居中的位置
      var left = (screen.width / 2) - (width / 2);
      var top = (screen.height / 2) - (height / 2);

      // 打开窗口
      window.open(url, '_blank', `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=${width}, height=${height}, top=${top}, left=${left}`);
    },
    addAdmin(){
      this.$emit("send",'addUser')
    },
    currPage(num){
      if(num==1){
        this.page=1
      }else if(num==5){
        this.page=this.countPage
      }else if(num==2){
        if(this.page>1){
          this.page-=1
        }
      }else{
        if(this.page<this.countPage){
          this.page+=1
        }
      }
      this.selectAdminList()
    },
    async selectAdminList(){
      let that=this
      loading("加载中")
      axiosGet(DO_NET_URL+"user/GetUserList?id="+this.id+"&account="+this.account+"&name="+this.name+"&phone="+this.phone+"&card="+this.card+
          "&level="+this.level+"&teamLevel="+this.teamLevel+"&recommender="+this.recommender+"&type="+this.type+"&state="+this.state+"&page="+this.page+"&num="+this.num,function (res){
        console.log(res.data)
        closeLoading()
        that.imgUrl=res.data.imgUrl
        that.adminList=res.data.list
        that.count=res.data.num
        let page=parseInt(res.data.num/that.num)
        if(res.data.num%that.num>0){
          page+=1
        }
        that.countPage=page
        localStorage.setItem("imgUrl",res.data.imgUrl)
      })
    },
  }
}
</script>

<style scoped>
.text1{
  border: 1px solid #dcdfe6;
  font-size: 12px;
  border-radius: 2px;
  outline: none;
  padding: 3px 10px;
}
.boxText{-webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: 12px;
  height: 35px;
  /*line-height: 40px;*/
  outline: none;
  padding: 0 15px;
  -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  width: 50%;}
.leftTd{
  vertical-align: middle;
  font-size: 12px;
  color: #606266;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;font-weight: 700;}
.addBtn{color: #1890ff;background: #e8f4ff; border: 1px solid #1890ff; cursor: pointer; float: left; font-size: 12px;padding: 7px 15px;border-radius: 3px;}
.th{border-bottom:1px solid #dfe6ec; text-align: left; padding:0 10px;word-break: break-word;background-color: #f8f8f9;color: #515a6e;height: 40px;font-size: 12px;}
.td{border-bottom:1px solid #dfe6ec;padding:0px 10px; min-width: 100px; width: auto; word-break:break-word;background-color: #ffffff;color: #606266;height: 40px;font-size: 12px;}
</style>